import { render, staticRenderFns } from "./hotellist.vue?vue&type=template&id=2894f561&scoped=true"
import script from "./hotellist.vue?vue&type=script&lang=js"
export * from "./hotellist.vue?vue&type=script&lang=js"
import style0 from "./hotellist.vue?vue&type=style&index=0&id=2894f561&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2894f561",
  null
  
)

export default component.exports